import { checkType } from './utils/functions'

const sessionStorage = global.sessionStorage
let memoryStorage = {}

export default Object.freeze({
  setItem(key, value) {
    checkType(key, value)

    memoryStorage[key] = value
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  getItem(key) {
    try {
      if (!memoryStorage[key]) {
        memoryStorage[key] = JSON.parse(sessionStorage.getItem(key))
      }
    } catch (error) {
      console.error(`sessionStorage formatter error: key=${key} option=${option}`)
    }
    return memoryStorage[key]
  },
  removeItem(key) {
    if (memoryStorage[key]) {
      delete memoryStorage[key]
    }
    sessionStorage.removeItem(key)
  },
  clear() {
    memoryStorage = {}
    sessionStorage.clear()
  },
})
